import { makeAutoObservable } from 'mobx'
import { type CountryCode } from 'libphonenumber-js'
import {
  type IRcsCountriesStepParams,
  type IRcsCountryCode,
  type IResponseRcsCompliance,
} from 'entities/Rcs'
import { toIsoCountryCode, toRcsCountryCode } from 'pages/settings/pages/rcsV2/lib/countryCode'

export class CountriesStore {
  private _selectedCountries: CountryCode[] = []
  private _paymentConsent = false

  constructor() {
    makeAutoObservable(this)
  }

  get selectedCountries() {
    return this._selectedCountries
  }

  get paymentConsent() {
    return this._paymentConsent
  }

  get hasUsSelected() {
    return this._selectedCountries.includes('US')
  }

  get params(): IRcsCountriesStepParams {
    return {
      country: this._selectedCountries
        .map(toRcsCountryCode)
        .filter((code): code is IRcsCountryCode => Boolean(code)),
      confirm: this.hasUsSelected ? this._paymentConsent : undefined,
    }
  }

  get isNextDisabled() {
    if (!this._selectedCountries.length) return true

    return this.hasUsSelected && !this._paymentConsent
  }

  isCountryActive = (country: CountryCode) => this._selectedCountries.includes(country)

  toggleCountry = (country: CountryCode) => {
    this._selectedCountries = this.isCountryActive(country)
      ? this._selectedCountries.filter((item) => item !== country)
      : [...this._selectedCountries, country]

    if (!this.hasUsSelected) this._paymentConsent = false
  }

  togglePaymentConsent = () => {
    this._paymentConsent = !this._paymentConsent
  }

  init = (data: IResponseRcsCompliance) => {
    this._selectedCountries = (data.data?.country ?? [])
      .map((item) => toIsoCountryCode(item.key))
      .filter((code): code is CountryCode => Boolean(code))
  }

  reset = () => {
    this._selectedCountries = []
    this._paymentConsent = false
  }
}
